/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_TomorrowInputs */

const en_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow`)
};

const de_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morgen`)
};

const es_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mañana`)
};

const fr_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demain`)
};

const nl_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morgen`)
};

const it_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domani`)
};

const pt_br2_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amanhã`)
};

const pl_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jutro`)
};

const hu_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holnap`)
};

const ro_admin_dashboard_tomorrow = /** @type {(inputs: Admin_Dashboard_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maine`)
};

/**
* | output |
* | --- |
* | "Tomorrow" |
*
* @param {Admin_Dashboard_TomorrowInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_tomorrow = /** @type {((inputs?: Admin_Dashboard_TomorrowInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_TomorrowInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_tomorrow(inputs)
	if (locale === "de") return de_admin_dashboard_tomorrow(inputs)
	if (locale === "es") return es_admin_dashboard_tomorrow(inputs)
	if (locale === "fr") return fr_admin_dashboard_tomorrow(inputs)
	if (locale === "nl") return nl_admin_dashboard_tomorrow(inputs)
	if (locale === "it") return it_admin_dashboard_tomorrow(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_tomorrow(inputs)
	if (locale === "pl") return pl_admin_dashboard_tomorrow(inputs)
	if (locale === "hu") return hu_admin_dashboard_tomorrow(inputs)
	return ro_admin_dashboard_tomorrow(inputs)
});
export { admin_dashboard_tomorrow as "admin.dashboard.tomorrow" }